import qs from "qs";
import request from "@/utils/api/helpers";

const baseUrl = "/finance/ledger-account-categories";

export const getLedgerAccountCategories = (params = {}) => {
  const headers = {
    includeCompanyId: true
  };

  const { companyId, includeCompanyId, ...rest } = params;

  if (typeof includeCompanyId === "boolean" && !includeCompanyId) {
    headers.includeCompanyId = false;
  }

  if (headers.includeCompanyId && companyId) {
    headers.Companyid = params.companyId;
  }

  const queryParams = qs.stringify(rest, {
    addQueryPrefix: true
  });

  return request({
    url: `${baseUrl}${queryParams}`,
    headers
  });
};

export const getLedgerAccountCategoryById = (id) =>
  request({
    url: `${baseUrl}/${id}`,
  });

export const createLedgerAccountCategory = (data) =>
  request({
    url: baseUrl,
    method: "POST",
    data,
  });

export const createMultiCompanyLedgerAccountCategory = (data) =>
  request({
    url: `${baseUrl}/multi-company`,
    method: "POST",
    data,
  });

export const updateLedgerAccountCategory = (id, data) =>
  request({
    url: `${baseUrl}/${id}`,
    method: "PATCH",
    data,
  });

export const deleteLedgerAccountCategory = (id) =>
  request({
    url: `${baseUrl}/${id}`,
    method: "DELETE",
  });
